import { render, staticRenderFns } from "./InsightParameters.vue?vue&type=template&id=d8312396&scoped=true&"
import script from "./InsightParameters.vue?vue&type=script&lang=ts&"
export * from "./InsightParameters.vue?vue&type=script&lang=ts&"
import style0 from "./InsightParameters.vue?vue&type=style&index=0&id=d8312396&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8312396",
  null
  
)

export default component.exports